<template>
  <div id="app">
    
    <div class="box">
      <router-view></router-view>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
* {margin: 0;padding: 0;list-style:none;text-decoration: none;}
#app{height: 100%;min-width: 1024px;font-family: "Calibri";}
.box{overflow:hidden;}
	.el-form-item__label{
		font-size: 18px !important;
		display: inline !important;
	}
</style>
